__turbopack_context__.v({
  "form": "styles-module-scss-module__kfFWZq__form",
  "name": "styles-module-scss-module__kfFWZq__name",
  "submit": "styles-module-scss-module__kfFWZq__submit",
});
